/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfOperationalOrganizationDetailDto } from "../models/AjaxResponseOfOperationalOrganizationDetailDto";
import type { AjaxResponseOfOperationalOrganizationPreviewDto } from "../models/AjaxResponseOfOperationalOrganizationPreviewDto";
import type { AjaxResponseOfPagedResultDtoOfOperationalOrganizationListDto } from "../models/AjaxResponseOfPagedResultDtoOfOperationalOrganizationListDto";
import type { CreateOperationalOrganizationInput } from "../models/CreateOperationalOrganizationInput";
import type { UpdateOperationalOrganizationInput } from "../models/UpdateOperationalOrganizationInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalOrganizationsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPagedResultDtoOfOperationalOrganizationListDto Success
   * @throws ApiError
   */
  public getAll({
    filter,
    state,
    city,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    state?: string;
    city?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfOperationalOrganizationListDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/organizations",
      query: {
        filter: filter,
        state: state,
        city: city,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalOrganizationDetailDto Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateOperationalOrganizationInput;
  }): CancelablePromise<AjaxResponseOfOperationalOrganizationDetailDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/organizations",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfOperationalOrganizationPreviewDto Success
   * @throws ApiError
   */
  public searchCnpj({
    cnpj,
  }: {
    cnpj: string;
  }): CancelablePromise<AjaxResponseOfOperationalOrganizationPreviewDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/organizations/search-cnpj/{cnpj}",
      path: {
        cnpj: cnpj,
      },
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public delete({
    organizationId,
  }: {
    organizationId: number;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/organizations/{organizationId}",
      path: {
        organizationId: organizationId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalOrganizationDetailDto Success
   * @throws ApiError
   */
  public get({
    organizationId,
  }: {
    organizationId: number;
  }): CancelablePromise<AjaxResponseOfOperationalOrganizationDetailDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/organizations/{organizationId}",
      path: {
        organizationId: organizationId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalOrganizationDetailDto Success
   * @throws ApiError
   */
  public update({
    organizationId,
    requestBody,
  }: {
    organizationId: number;
    requestBody?: UpdateOperationalOrganizationInput;
  }): CancelablePromise<AjaxResponseOfOperationalOrganizationDetailDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/organizations/{organizationId}",
      path: {
        organizationId: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
